import { FunctionComponent } from "react";

import { ProgressSpinner } from "primereact/progressspinner";

import "./LoadingPage.scss";

interface ILoadingPageProps {
  loadingInformation?: string;
}

export const LoadingPage: FunctionComponent<ILoadingPageProps> = (props: ILoadingPageProps) => {
  return (
    <div className="page-loading">
      <ProgressSpinner animationDuration="5s" />

      {!!props.loadingInformation && <span>{props.loadingInformation}</span>}
    </div>
  );
};
